export const FETCH_UPDATE_COMPNY_BY_ID_REQUEST = 'FETCH_UPDATE_COMPNY_BY_ID_REQUEST'
export const FETCH_UPDATE_COMPNY_BY_ID_SUCCESS = 'FETCH_UPDATE_COMPNY_BY_ID_SUCCESS'
export const FETCH_UPDATE_COMPNY_BY_ID_FALUIRE = 'FETCH_UPDATE_COMPNY_BY_ID_FALUIRE'
